<template>
  <div class="main-content">
    <!-- Login Start-->
    <section class="section login-form m-0 pb-0">

      <!-- Overlay Start -->
      <b-overlay :show="busy" no-wrap>
        <template #overlay>
          <b-spinner label="Loading..."></b-spinner>
        </template>
      </b-overlay>
      <!-- Overlay End -->

      <!-- Login Container Start -->
      <div class="container-fluid p-0">
        <div class="login-container">
          <div :style="{ minHeight: `${containerHeight}px`, }" class="row h-100 mt-0">
            <div class="col-12 col-md-6 col-lg-5 col-xl-5 p-0 d-flex justify-content-center align-items-center">
              <div :class="signInSignUpRightBorder" class="signIn-SignUp-Section pl-lg-5 pl-xl-5 pt-5 pb-5 d-flex flex-column justify-content-center align-items-center">
                <div style="height: 285px; padding-bottom: 8px;" class="d-flex flex-column justify-content-between">
                  <div class="w-100 row m-0">
                    <div class="col-12 p-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start align-items-start">
                      <div class="text-center text-md-left text-lg-left text-xl-left login-header-title text-display">
                        Register
                      </div>
                    </div>
                  </div>

                  <div style="max-height: 120px;" class="w-100 row m-0 my-4 my-lg-3 my-xl-3">
                    <div class="col-12 p-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start align-items-center">
                      <div class="text-left login-header-text">
                        Don’t have an account? Register to begin your organization’s cyber success journey today
                      </div>
                    </div>
                  </div>

                  <div class="w-100 row m-0">
                    <div class="col-12 p-0 text-left 
                    d-flex 
                    flex-row 
                    justify-content-center 
                    justify-content-md-end 
                    justify-content-lg-start 
                    justify-content-xl-start 
                    align-items-end"
                    >

                      <router-link
                        :to="{
                            name: 'signup',
                        }"
                      >
                        <v-btn
                          class="mb-3 mb-md-0 mb-lg-0 mb-xl-0"
                          rounded
                          large
                          dark
                          :color="'#424EC4'"
                          width="160"
                          @click="''"
                        >
                          Register
                        </v-btn>
                      </router-link>

                      <router-link
                        :to="{
                            name: 'index',
                        }"
                      >
                        <v-btn
                          class="ml-4 mb-3 mb-md-0 mb-lg-0 mb-xl-0"
                          rounded
                          outlined
                          large
                          dark
                          :color="'#ffffff'"
                          @click="onPasswdReset"
                        >
                          Back to Home
                        </v-btn>
                      </router-link>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-7 col-xl-7 pl-lg-5 pl-xl-5 p-0 mt-4 mt-lg-0 mt-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start align-items-start align-items-md-center align-items-lg-center align-items-xl-center">
              <!-- MAIN FORM LOGIN START -->
              <form 
                v-if="form.currentLoginState == LoginState.LOGIN"
                @submit.prevent 
                class="form-element form-body p-0"
              >
                <div class="text-center section-title">
                  <h2 class="text-center text-lg-left text-xl-left text-display">Sign In</h2>
                </div>
                <div class="mt-4">
                  <div class="row m-0">
                    <div class="col-12 p-0">
                      <div class="form-group">
                        <label 
                          :style="{ color: form.isInvalid.email ? invalidFormLabelColor : '#fff' }"
                        >Email</label>
                        <b-form-input
                          type="text"
                          :state="validateState('email')"
                          required="required"
                          v-model="form.email"
                          autocomplete="username"
                          @input="inputChangeHandler"
                        />
                        <b-form-invalid-feedback id="input-phone-feedback">
                          Email is required
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="col-12 p-0">
                      <div class="form-group password-input-field">
                        <label 
                          :style="{ color: form.isInvalid.password ? invalidFormLabelColor : '#fff' }"
                        >Password</label>
                        <b-form-input
                          :type="passwordInputFieldType"
                          :state="validateState('password')"
                          name="password"
                          required="required"
                          v-model="form.password"
                          autocomplete="current-password"
                          @input="inputChangeHandler"
                        />
                        <b-form-invalid-feedback id="input-phone-feedback">
                          Password is required
                        </b-form-invalid-feedback>
                        <span
                          :style="{ right: isPasswordUpdated ? '35px' : '10px' }"
                          class="password-icon"
                          @click="isPasswordTextInputField = !isPasswordTextInputField"
                        >
                          <i
                            v-if="!isPasswordTextInputField"
                            class="fa fa-eye custom-color"
                          ></i>
                          <i v-else class="fa fa-eye-slash custom-color"></i>
                        </span>
                      </div>
                    </div>

                    <!-- THIS IS THE FIELD FOR THE USER'S LIMITED LIABILITY AGREEMENT (LLA) -->
                    <LlaAgreementWidget
                      v-if="showLLAAgreement"
                      :llaStatus="form.iagreeStatus"
                      :username="username"
                      :llaColor="'#FFCD00'"
                      :textColor="'#E6E6E6'"
                      :llaAgreementStatusHandler="llaAgreementStatusHandler"
                      :llaStatement="'* Your session has expired. To continue using Project Spectrum, you must review and agree to the'"
                    />
                  </div>
                  <div class="row m-0 mb-3 mb-lg-0 mb-xl-0">
                    <div v-if="!!error" class="col-12 alert alert-danger text-center text-lg-left text-xl-left my-3">
                      {{ error }}
                    </div>
                    <div class="col-sm-12 px-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start align-items-center">

                      <v-btn
                        rounded
                        large
                        dark
                        :color="'#424EC4'"
                        width="160"
                        @click="login"
                      >
                        Log In 
                      </v-btn>

                      <v-btn
                        class="ml-4"
                        rounded
                        outlined
                        large
                        dark
                        :color="'#ffffff'"
                        @click="onPasswdReset"
                      >
                        Forgot Password 
                      </v-btn>
                    </div>
                  </div>
                </div>
              </form>
              <!-- MAIN FORM LOGIN START -->

              <!-- PASSWORD RESET FOR EMAIL CODE FORM START -->
              <form 
                v-if="form.currentLoginState == LoginState.SEND_EMAIL_CODE"
                @submit.prevent 
                class="form-element form-body"
              >
                <div class="text-center section-title">
                  <h2 class="text-center text-lg-left text-xl-left text-display">Password Reset</h2>
                </div>

                <div class="mt-4">
                  <div class="row m-0">
                    <div class="col-12 p-0">
                      <div class="form-group">
                        <label 
                          :style="{ color: form.isInvalid.email ? invalidFormLabelColor : '#fff' }"
                        >Email</label>
                        <b-form-input
                          type="text"
                          :state="validateState('email')"
                          required="required"
                          v-model="form.email"
                          autocomplete="username"
                        />
                        <b-form-invalid-feedback id="input-phone-feedback">
                          Email is required
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                  </div>
                  <div class="row m-0 mt-3">
                    <div v-if="!!error" class="col-12 alert alert-danger text-center text-lg-left text-xl-left my-3">
                      {{ error }}
                    </div>
                    <div class="col-sm-12 p-0 d-flex flex-row justify-content-center justify-content-md-start justify-content-lg-start justify-content-xl-start">

                      <v-btn
                        rounded
                        large
                        dark
                        :color="'#424EC4'"
                        width="160"
                        @click="sendResetCode"
                      >
                        Email Code 
                      </v-btn>

                      <v-btn
                        class="ml-4"
                        rounded
                        outlined
                        large
                        dark
                        :color="'#ffffff'"
                        @click="form.currentLoginState = LoginState.LOGIN"
                      >
                        Back to Log In 
                      </v-btn>
                    </div>
                  </div>
                </div>
              </form>
              <!-- PASSWORD RESET FOR EMAIL CODE FORM END -->
              
              <!-- PASSWORD RESET FOR START -->
              <form 
                v-if="form.currentLoginState == LoginState.RESET_PASSWORD"
                @submit.prevent 
                class="form-element form-body"
              >
                <div class="text-center section-title">
                  <h2 class="text-center text-lg-left text-xl-left text-display">Password Reset</h2>
                </div>

                <div class="mt-4">
                  <div class="row m-0">
                    <div class="col-12 p-0">
                      <div class="form-group">
                        <label 
                          :style="{ color: form.isInvalid.email ? invalidFormLabelColor : '#fff' }"
                        >Email</label>
                        <b-form-input
                          type="text"
                          :state="validateState('email')"
                          required="required"
                          v-model="form.email"
                          autocomplete="username"
                        />
                        <b-form-invalid-feedback id="input-phone-feedback">
                          Email is Required
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="col-12 p-0">
                      <div class="form-group">
                        <label 
                          :style="{ color: form.isInvalid.code ? invalidFormLabelColor : '#fff' }"
                        >Code</label>
                        <b-form-input
                          type="number"
                          :state="validateState('code')"
                          required="required"
                          v-model="form.code"
                          autocomplete="username"
                        />
                        <b-form-invalid-feedback id="input-phone-feedback">
                          Verification Code is Required (sent to your email)
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="col-12 p-0">
                      <div class="form-group password-input-field">
                        <label 
                          :style="{ color: form.isInvalid.password ? invalidFormLabelColor : '#fff' }"
                        >Password</label>
                        <b-form-input
                          :type="passwordInputFieldType"
                          :state="validateState('password')"
                          name="password"
                          required="required"
                          v-model="form.password"
                          autocomplete="current-password"
                        />
                        <div
                          v-if="!validateState('password')"
                          class="invalid-feedback"
                        >
                          <div class="error" v-if="!$v.form.password.required">
                            Password is required
                          </div>
                          <div
                            class="error"
                            v-if="!$v.form.password.goodPassword"
                          >
                            Must be at least 8 characters and contain a
                            lowercase, uppercase, number and special character.
                          </div>
                        </div>
                        <small
                          id="passwordHelpBlock"
                          class="form-text text-muted"
                          v-if="$v.form.password.goodPassword"
                        >
                          Must be at least 8 characters and contain a lowercase,
                          uppercase, number and special character.
                        </small>
                        <span
                            :style="{ right: isPasswordUpdated ? '35px' : '10px' }"
                            class="password-icon"
                            @click="isPasswordTextInputField = !isPasswordTextInputField"
                          >
                            <i
                              v-if="!isPasswordTextInputField"
                              class="fa fa-eye custom-color"
                            ></i>
                            <i v-else class="fa fa-eye-slash custom-color"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div class="row m-0 mt-3">
                    <div v-if="!!error" class="col-12 alert alert-danger text-center text-lg-left text-xl-left my-3">
                      {{ error }}
                    </div>

                    <div class="col-sm-12 p-0 d-flex flex-row justify-content-center justify-content-md-start justify-content-lg-start justify-content-xl-start">
                      <v-btn
                        rounded
                        large
                        dark
                        :color="'#424EC4'"
                        width="160"
                        @click="passwordreset"
                      >
                        Reset Password 
                      </v-btn>
                    </div>

                    <div class="col-sm-12 p-0 d-flex flex-row justify-content-center justify-content-md-start justify-content-lg-start justify-content-xl-start mt-4">
                      <b-alert
                        :variant="dismissableAlertVariant"
                        class="mt-1"
                        dismissible
                        fade
                        :show="showDismissibleAlert"
                        @dismissed="showDismissibleAlert = false"
                      >
                        {{ dismissableAlertText }}
                      </b-alert>
                    </div>
                  </div>
                </div>
              </form>
              <!-- PASSWORD RESET FOR END -->

            </div>
          </div>
        </div>
      </div>
      <!-- Login Container End -->
    </section>

  </div>
</template>
<script>
import axios from "axios"
import { required, email, requiredIf, helpers } from "vuelidate/lib/validators"
import { validationMixin } from "vuelidate"
import { storeAuthTokens, isLoggedIn, setUser, clearAuthTokens } from "../utils/authentication"
import PageHeader from "./library/widgets/page-header.vue";
import PageHeaderTitleContent from "./library/widgets/page-header-title-content.vue";
import TitleTextContent from "./library/widgets/title-text-content.vue";
import LlaAgreementWidget from "./library/widgets/lla-agreement-widget.vue";
import { EventBus } from "../utils/eventBus";
const LoginState = {
  LOGIN: 0,
  SEND_EMAIL_CODE: 1,
  RESET_PASSWORD: 2,
}

function isPasswordValidationRequired(value, vm) {
  return vm.currentLoginState === LoginState.RESET_PASSWORD
}

const isPasswordGood = (password, vm) =>
  !isPasswordValidationRequired(password, vm) ||
  (password.length >= 8 &&
    /[a-z]/.test(password) &&
    /[A-Z]/.test(password) &&
    /[0-9]/.test(password) &&
    /[#?!@$%^&*-]/.test(password))

export default {
  mixins: [validationMixin],
  name: 'login',
  props: ['redirect', 'queryString', 'queryValue'],
  components: {
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
    LlaAgreementWidget,
  },
  data() {
    return {
      busy: false,
      error: "",
      form: {
        email: "",
        password: "",
        code: "",
        iagreeStatus: null,
        iagree: null,
        currentLoginState: LoginState.LOGIN,
        isInvalid: {
          email: false,
          password: false,
          code: false,
        }
      },
      LoginState,
      showDismissibleAlert: false,
      dismissableAlertText: "Dismissable Alert",
      dismissableAlertVariant: "danger",
      isPasswordTextInputField: false,
      username: null,
      userGroup: null,
      body: null,
      showLLAAgreement: false,
    }
  },
  validations: {
    form: {
      email: { required, email },
      password: {
        required: requiredIf(function () {
          return (
            this.form.currentLoginState == LoginState.LOGIN ||
            this.form.currentLoginState == LoginState.RESET_PASSWORD
          )
        }),
        isPasswordGood,
      },
      code: {
        required: requiredIf(function () {
          return this.form.currentLoginState == LoginState.RESET_PASSWORD
        }),
      },
    },
  },
  mounted() {
    //console.log('Redirect', this.redirect);
    EventBus.$emit("activate-indicated-menu-item", "Sign In/Register");
    this.init()
    if (isLoggedIn()) this.$router.push({ path: "my-account" })
  },
  destroyed() {
    window.removeEventListener('resize', this.computePageContainerHeight);
  },
  computed: {
    signInSignUpRightBorder() {
      return this.$vuetify.breakpoint.xs 
                ? 'signIn-Signup-rightBorder-xs' 
                : (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) && 'signIn-Signup-rightBorder-lg-xl';
    },
    passwordInputFieldType() {
      // Determine the password field with respect to the isPasswordTextInputField boolean field
      return this.isPasswordTextInputField ? 'text' : 'password';
    },
    isPasswordUpdated() {
      // Checks for verifying password change
      return this.$v.form.password.$dirty || this.$v.form.password.$error;
    },
  },
  methods: {
    onPasswdReset() {
      this.form.currentLoginState = LoginState.SEND_EMAIL_CODE
      this.$v.$reset()
      //console.log('Send Email Code State');
    },
    inputChangeHandler() {
      this.body &&= null;
      this.form.iagreeStatus = null;
      this.showLLAAgreement = false;
    },
    llaAgreementStatusHandler(llaAgreementStatusValue, statusValue) {
      this.form.iagree = llaAgreementStatusValue;
      this.body = { ...this.body, iagree: this.form.iagree };
      this.form.iagreeStatus = statusValue ? statusValue : null;
    },
    async sendResetCode() {
      const sendResetCode = await this.sendResetVerificationCode()
      if (sendResetCode) {
        this.form.currentLoginState = LoginState.RESET_PASSWORD
        this.$v.$reset()
        //console.log('Reset Password State');
      } else {
        console.warn("Problem sending reset verification email")
      }
    },
    async passwordreset() {
      const passwordReset = await this.resetPassword()
      if (passwordReset) {
        this.dismissableAlertText = "Password Reset! Redirecting to Login Page"
        this.showDismissibleAlert = true
        this.dismissableAlertVariant = "success"
        var delayInMilliseconds = 2000 //1 second
        setTimeout(() => {
          this.form.currentLoginState = LoginState.LOGIN
          this.$v.$reset()
          console.log("Login State")
        }, delayInMilliseconds)
      } else {
        this.dismissableAlertText = "Password Reset Failed!"
        this.showDismissibleAlert = true
        this.dismissableAlertVariant = "danger"
        console.warn("Problem sending reset verification email")
      }
    },
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();

      this.computePageContainerHeight();
      window.addEventListener('resize', this.computePageContainerHeight);
    },
    initFooterHeight() {
      var footerHeight = $("footer").outerHeight()
      $(".main-content").css("margin-bottom", footerHeight)
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      this.form.isInvalid[name] = $error;
      return $dirty ? !$error : null
    },
    setUserResponse(responseData) {
      const UserGroup = {
        INDIVIDUAL: "Individual",
        ORG_ADMIN: "OrganizationAdmin",
        ORG_MEMBER: "OrganizationMember",
      };

      const body = {};

      // Set the Individual User Data
      body.firstName = responseData.name.split(" ")[0];
      body.lastName = responseData.name.split(" ")[1];
      body.email = responseData.email;
      body.forumScreenName = responseData.forumScreenName;
      body.streetAddress1 = responseData.address1;
      body.streetAddress2 = responseData.address2;
      body.city = responseData.city;
      body.state = responseData.state;
      body.zipcode = responseData.zipcode;
      body.country = responseData.country;
      body.telephone = responseData.phone_number?.replace("+1", "");
      body.mfa = responseData.mfa;
      body.titleInOrganization = responseData.titleInOrganization;
      body.referringOrganization = responseData.referringOrganization;

      // Set the Organization Admin Data
      if(this.userGroup === UserGroup.ORG_ADMIN) {
        body.organization = responseData.organization;
        body.website = responseData.website;
        body.organizationType = responseData.organizationType;
        body.CAGECode = responseData.CAGECode;
        body.NAICSCodes = responseData.NAICSCodes;
        body.numberOfEmployees = responseData.numberOfEmployees;
        body.annualRevenues = responseData.annualRevenues;
        body.DUNSNumber = responseData.DUNSNumber;
      }

      this.body = body;
    }, 
    async resetPassword() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return false
      }
      this.busy = true
      await axios
        .put("/api/user/password", {
          username: this.form.email,
          verificationCode: this.form.code,
          newPassword: this.form.password,
        })
        .then((response) => {
          this.error = ""
          //console.log(response);
        })
        .catch((error) => {
          this.error = error.response.data.message
          console.error(error.response)
        })
        .finally(() => {
          this.busy = false

          // Reset this field for showing password to its initial value.
          this.isPasswordTextInputField = false;

        })
      return !this.error
    },
    async sendResetVerificationCode() {
      // Verify the form input fields
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return false
      }
      //console.log('Gettig Email Code');
      this.busy = true
      await axios
        .post("/api/user/password/forgot/code", {
          email: this.form.email,
        })
        .then((response) => {
          this.error = ""
          //console.log(response);
        })
        .catch((error) => {
          this.error = error.response.data.message
          console.error(error)
        })
        .finally(() => {
          this.busy = false
          //console.log('return', !this.error);
        })
      return !this.error
    },
    updateUser() {
      // If the LLA Agreement is shown and IAgree form field has received its value, update the User data with IAgree value
      axios
        .put("/api/user/", this.body)
        .then((response) => {
          this.showLLAAgreement = false;
          this.getUser();
        })
        .catch((error) => {
          this.error = "Unable to update the User...";
          console.error(error.response.data.message);
        });
    },
    getUser() {
      axios.get(`/api/user/`).then((response) => {
        const { iagree, forumScreenName, user_group } = response.data;
        // THE USER MUST AGREE TO THE LLA AGREEMENT BEFORE LOGGING IN SUCCESSFULLY
        if(!iagree) {
          if(this.error) {
            this.error = null;
          }

          this.userGroup = user_group;
          this.setUserResponse(response.data);
          clearAuthTokens();

          this.username = forumScreenName;
          this.showLLAAgreement = true;

          return;
        }

        setUser(response.data)
        /** Redirect to the link from the query params, or account info */
        if (this.redirect &&  this.queryString && this.queryValue) {
          this.$router.push({ path: this.redirect + "?" + this.queryString + "=" + this.queryValue});
        }
        else if(this.redirect) {
          this.$router.push({ path: this.redirect});
        }
        else {
          this.$router.push({ path: '/' });
        }
      });
    },
    login() {
      // Verify the form input fields
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }

      // Verify that the Limited Liability Agreement checkbox is checked
      if(this.body && !this.body.iagree) {
        this.form.iagreeStatus = false;
        return;
      }

      //console.log('Loging In');
      this.busy = true
      /** Login */ 
      const email = this.form.email
      axios
        .post("/api/user/login", {
          username: email,
          password: this.form.password,
        })
        .then((response) => {
          if (response?.data?.message === "SMS_MFA") {
            /* Check if MFA required */
            //console.log('Login Successful, but redirecting to MFA', response);
            this.$router.push({
              path: "verify-mfa",
              query: {
                session: response.data.session,
                username: email,
                redirect: this.redirect,
                queryString: this.queryString, queryValue: this.queryValue
              },
            })
          } else if (response?.data?.message === "NEW_PASSWORD_REQUIRED") {
            /* Check if New Password required */
            /*console.log(
              'Login Successful, but new password required',
              response
            );*/
            this.$router.push({
              path: "new-password",
              query: {
                session: response.data.session,
                username: email,
                redirect: this.redirect,
                queryString: this.queryString, 
                queryValue: this.queryValue
              },
            })
          } else {
            //console.log('Login Successful', response);
            storeAuthTokens(response.data)

            if(this.showLLAAgreement && this.form.iagree) {
              // Update User with iagree
              this.updateUser();
            }
            else {
              // Get User Data
              this.getUser();
            }
          }
        })
        .catch((error) => {
          if (error.response.data.code == "UserNotConfirmedException") {
            // forward user to email verification page.
            // err.config.data.username is email
            var body = {
              username: JSON.parse(error.response.config.data).username,
            }
            axios.post("/api/user/email/code/resend", body).then((response) => {
              this.$router.push({
                path: "verify",
                query: {
                  email: JSON.parse(error.response.config.data).username,
                  message: "Please verify your email before logging in.",
                },
              })
            })
          } else {
            this.error = error.response.data.message
            console.error(error.response)
          }
        })
        .finally(() => {
          this.busy = false

          // Reset this field for showing password to its initial value.
          this.isPasswordTextInputField = false;

          for(key of Object.keys(this.form.isInvalid)) {
            this.form.isInvalid[key] = false;
          }
        })
    },
  },
}
</script>
<style scoped>
.inner-header-bg {
  background-image: url("~@/assets/images/headers/login.png");
  background-position: center center;
}
.loading-gif {
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin: auto;
}

.login-form {
  top: 0 !important;
  padding-bottom: 12px !important;
}
.login-container {
  background-image: url('~@assetsImages/HomepageBannerHeader.png');
  background-position: center center;
  background-size: cover;
}
.form-element {
  width: 70%;
  min-width: 350px;
}
.text-display {
  color: #FFF;
  font-style: normal;
  font-family: GeomGraphic;
  font-weight: 400;
}
h2 {
  font-size: 28px;
  line-height: normal;
}
label {
  color: #FFF;
  font-family: Rajdhani;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-transform: uppercase;
  margin: 0;
}
.login-header-title {
  font-size: 28px;
  line-height: 50px;
  width: 200px;
}
.login-header-text {
  color: #E6E6E6;
  font-family: Rajdhani;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  max-width: 260px;
}
input[type="text"], 
input[type="password"], 
input[type="number"] {
  height: 40px;
}
.signIn-SignUp-Section {
  width: 100%;
  min-width: 375px;
  max-width: 500px;
  height: 85%;
}
.signIn-Signup-rightBorder-lg-xl {
  border-right: 1px dashed #fff;
}
.signIn-Signup-rightBorder-xs {
  border-bottom: 1px dashed #fff;
}
.password-input-field {
  position: relative;
}
.password-icon {
  position: absolute;
  top: 33px;
  cursor: pointer;
}
.custom-color {
  color: #6c757d;
}

@media (max-width: 991px) {
  .section {
    padding-top: 80px !important;
  }
}
</style>
